import { Text, NavLink } from '@mantine/core';
import React from 'react';
import { theme } from '../consilitheme';

const SidePanel = ({ handlePanelChange, panelNumber, isStaffUser }) => {
  const panelNames = isStaffUser
    ? ['Discovery', 'Synthesis', 'Triggers', 'Support', 'Operations']
    : ['Discovery', 'Synthesis', 'Triggers', 'Support'];

  const buttonProps = {
    fullWidth: true,
    size: 'xl',
    variant: 'default',
    className: 'side-panel-button',
    width: '100%',
    height: '2.8rem',
  };

  const isPanelActive = (num) => {
    return num === panelNumber;
  };

  return (
    <>
      {panelNames.map((panelName, index) => (
        <NavLink
          key={index}
          onClick={() => handlePanelChange(index)}
          leftSection={<Text fw={500}>{panelName}</Text>}
          c={
            isPanelActive(index) ? theme.colors.blue[4] : theme.colors.black[1]
          }
          style={buttonProps}
          active={isPanelActive(index)}
        ></NavLink>
      ))}
    </>
  );
};

export default SidePanel;
